<template>
	<div>

		<p class="page-title text-left mb-3 mt-5">{{$lang.SUBSCRIPTION_HISTORY.toUpperCase()}}</p>


		<v-data-table
		v-model="selected"
		:headers="headers"
		:items="sunsbscription_list"
		:hide-default-footer="true"
		:disable-sort="true"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<template v-slot:item.activation_state="{ item }">
			<span :class="item.activation_state.toLowerCase()+'-subscription'">
				{{item.activation_state}}
			</span>
		</template>	
		<!-- plan_name -->
		<template v-slot:item.plan_name="{ item }">
			<p>
				{{item.plan_name}}
				<span v-if="item.plan_type==$keys.ADDON_PLAN" class="addon_plan">{{item.plan_type}}</span>
			</p>
		</template>	

		<template v-slot:item.invoice="{ item }">
			<v-btn small fab text @click="downloadInvoice(item.order_id)" v-if="!item.is_free">	
				<img src="@/assets/download.svg" alt="">	
			</v-btn>	
		</template>	
	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getSubscriptionHistory"></v-pagination>
</div>
</template>
<script>
export default{
	data(){
		return{
			page_number:1,
			total_page_count:1,
			table_loading:false,
			sunsbscription_list:[],
			selected:[],
			headers: [
			{ text: 'Transaction ID', value: 'order_id' },
			{ text: 'Purchased On', value: 'purchased_on' },
			{ text: 'Plan', value: 'plan_name' },
			{ text: 'Price', value: 'amount' },
			{ text: '', value: 'activation_state',align:'center' },
			{ text: 'Invoice', value: 'invoice' },
			],
		}
	},
	created(){
		this.getSubscriptionHistory();
	},
	methods:{
		getSubscriptionHistory(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};

			self.table_loading
			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.sunsbscription_list=response.data.subscription_list
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTON_HISTORY,params,successHandler,null,null,finallyHandler)
		},
		/* oenload subscription invoice */ 
		downloadInvoice(subscription_id){
			const self=this
			const reqListener = () => {
				if(xhr.status==200){
					var arrayBuffer = xhr.response;
					var fileURL = URL.createObjectURL(xhr.response);
					window.open(fileURL);
				}
			};

			let url =this.$urls.BASE_URL+"transactions/get-pdf/?order_id="+subscription_id
			console.log(url)
			var xhr = new XMLHttpRequest();
			xhr.addEventListener("load", reqListener);
			xhr.open("GET", url); 
			xhr.responseType="blob"; 
			xhr.overrideMimeType("application/pdf; charset=x-user-defined");
			xhr.send(); 
			console.log(xhr)
		},
	}
}

</script>